(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

var mdiIsNativeShell = function mdiIsNativeShell() {
    // an array (true) or null (false) is returned and cast to boolean
    return !!window.navigator.userAgent.match(/(Mdi Native Shell)/);
};

var startScan = function startScan() {
    var $input1 = $('#ticket1_1_1');
    var $input2 = $('#ticket1_2_1');
    var $input3 = $('#ticket1_2_2');
    var $input4 = $('#ticket1_2_3');

    var $draw1 = $('#ticket1_1_1');
    var $draw2 = $('#ticket1_1_2');
    var $draw3 = $('#ticket1_1_3');
    var $draw4 = $('#ticket1_1_4');
    var $draw5 = $('#ticket1_1_5');

    $('#scanned-invalid-ticket').hide();

    // these inputs should be cleared
    var $clearVals = [$input1, $input2, $input3, $input4, $draw1, $draw2, $draw3, $draw4, $draw5];
    // these inputs should have readonly removed
    var $makeWriteable = [$input1, $input2, $input3, $input4, $draw1, $draw2, $draw3, $draw4, $draw5];

    var scanCallback = function scanCallback(infoObject) {
        $clearVals.map(function ($item) {
            $item.val('');
        });
        $makeWriteable.map(function ($item) {
            $item.removeAttr('readonly');
        });

        var sub1 = infoObject.format.toUpperCase();
        var resultLength = infoObject.result.length;
        var eligibleGames = [5045, 5046, 1367, 1368, 1369, 1370, 1371, 1372];

        if (sub1 != 'UNDEFINED' && infoObject.result != null && infoObject.result != '') {
            if (resultLength < 35) {
                $.ajax({
                    url: '/general/app_common/mobileAppEntry.php',
                    type: 'post',
                    async: false,
                    dataType: 'json',
                    data: { barcode: infoObject.result },
                    success: function success(res) {
                        if (eligibleGames.includes(window.parseInt(res.gameid, 10))) {
                            $('#entry_method').val('SCAN_APP');
                            $('#ticket1_1_1, #3ticket1_1_1').val(res.virn);
                            $('[name="ticket1_2_1"]').val(res.gameid);
                            $('#ticket1_2_2, #3ticket1_2_2').val(res.booknum);
                            $('#ticket1_2_3, #3ticket1_2_3').val(res.tktnum);
                            $('#promotion_game_id').val(res.gameid);
                            $('.form-back-button').hide();
                            window.showEntryForm(window.parseInt(res.gameid, 10));
                        } else {
                            $('#scanned-invalid-ticket').show();
                            $('#entry-view, #desktop-landing').hide();
                            $('#app-landing').show();
                            $('.form-back-button').show();
                        }
                    },
                    error: function error(err) {
                        console.warn('Request failed: ', err);
                    }
                });
            } else if (resultLength > 35) {

                var webCodeBarCodeStringArray = infoObject.result.split('w');
                var webCodeBarCode = webCodeBarCodeStringArray[1];

                if (webCodeBarCode.length === 25) {
                    $('[name="entry_method"]').val('SCAN_APP');
                    $draw1.val(webCodeBarCode.substr(0, 5));
                    $draw2.val(webCodeBarCode.substr(5, 5));
                    $draw3.val(webCodeBarCode.substr(10, 5));
                    $draw4.val(webCodeBarCode.substr(15, 5));
                    $draw5.val(webCodeBarCode.substr(20));
                    $('.form-back-button').hide();
                    window.showEntryForm('draw');
                } else {
                    console.warn('Request Failed. Web code does NOT contain > 35 characters');
                    $('#scanned-invalid-ticket').show();
                    $('#entry-view, #desktop-landing').hide();
                    $('#app-landing').show();
                    $('.form-back-button').show();
                }
            } else {
                console.warn('invalid barcode.');
            }
        }
    };

    window.MdiNativeShell.scanBarcode(scanCallback);
};

module.exports = {
    mdiIsNativeShell: mdiIsNativeShell,
    mdiStartScan: startScan
};

},{}],2:[function(require,module,exports){
'use strict';

var fastPlayIdentifiers = [5045, 5046, 'fast-play'];
var scratchOffIdentifiers = [1367, 1368, 1369, 1370, 1371, 1372, 'scratch-off'];

var showEntryForm = function showEntryForm() {
    var identifier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;


    $('#fast-play, #scratch-off, #draw').hide();

    var showWhich = fastPlayIdentifiers.includes(identifier) ? 'fast-play' : scratchOffIdentifiers.includes(identifier) ? 'scratch-off' : identifier === 'draw' ? 'draw' : null;

    if (showWhich === 'fast-play' || showWhich === 'scratch-off') {
        buildSelectElements(showWhich, identifier);
    }

    $('#desktop-landing, #app-landing, #scanned-invalid-ticket').hide();
    $('#entry-view, #' + showWhich).show();
    $('#ticket_type').val(showWhich);

    if (typeof initSameHeight !== 'undefined') {
        initSameHeight();
    }
};

var buildSelectElements = function buildSelectElements() {
    var showWhich = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var identifier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;


    $('#ticket1_2_1').remove();
    $('[name="ticket1_2_1"]').remove();

    var gameIDs = {
        'scratch-off': [1367, 1368, 1369, 1370, 1371, 1372],
        'fast-play': [5045, 5046]
    };

    var $gameSelect = $('<select />').attr({
        name: 'ticket1_2_1',
        class: 'form-control'
    });

    $('<option />').appendTo($gameSelect);

    if (showWhich != null) {
        gameIDs[showWhich].forEach(function (gameID) {
            $('<option />', {
                value: gameID,
                text: gameID,
                class: 'game-option ' + showWhich + '-option'
            }).appendTo($gameSelect);
        });
    } else {
        // this is really is only used if something has gone wrong.
        // a situation might involve scanning a ticket that doesn't fit
        // into the list of approved games.
        Object.keys(gameIDs).forEach(function (key, index) {
            gameIDs[key].forEach(function (gameID) {
                $('<option />', {
                    value: gameID,
                    text: gameID,
                    class: 'game-option ' + key + '-option'
                }).appendTo($gameSelect);
            });
        });
    }

    $('.game-number-container').after($gameSelect);

    if (typeof identifier === 'number') {
        $('[name="ticket1_2_1"]').val(identifier);
    }
};

var showManualChoices = function showManualChoices() {
    $('#app-landing, #scanned-invalid-ticket').hide();
    $('#desktop-landing').show();
    showEntryForm('draw');
};

var queryStringValue = function queryStringValue(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

var getKeyValueFromQuery = function getKeyValueFromQuery(query) {
    return function (name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(query);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };
};

var inputAutotab = function inputAutotab(current, next) {
    if (current.getAttribute && current.value.length === parseInt(current.getAttribute('maxlength'))) {
        next.focus();
    }
};

var sourceSwap = function sourceSwap() {
    var $this = $(this);
    var newSource = $this.data('alt-src');
    $this.data('alt-src', $this.attr('src'));
    $this.attr('src', newSource);
};

var ieVersion = function () {
    var undef = undefined;
    var div = document.createElement('div');
    var all = div.getElementsByTagName('i');
    var v = 3;
    while (div.innerHTML = '<!--[if gt IE ' + ++v + ']><i></i><![endif]-->', all[0]) {}
    return v > 4 ? v : undef;
}();

module.exports = {
    showManualChoices: showManualChoices,
    queryStringValue: queryStringValue,
    getKeyValueFromQuery: getKeyValueFromQuery,
    showEntryForm: showEntryForm,
    autotab: inputAutotab,
    altSourceSwap: inputAutotab,
    ieVersion: ieVersion
};

},{}],3:[function(require,module,exports){
'use strict';

// https://tc39.github.io/ecma262/#sec-array.prototype.includes
if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, 'includes', {
        value: function value(searchElement, fromIndex) {

            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            // 1. Let O be ? ToObject(this value).
            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If len is 0, return false.
            if (len === 0) {
                return false;
            }

            // 4. Let n be ? ToInteger(fromIndex).
            //    (If fromIndex is undefined, this step produces the value 0.)
            var n = fromIndex | 0;

            // 5. If n ≥ 0, then
            //  a. Let k be n.
            // 6. Else n < 0,
            //  a. Let k be len + n.
            //  b. If k < 0, let k be 0.
            var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

            function sameValueZero(x, y) {
                return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
            }

            // 7. Repeat, while k < len
            while (k < len) {
                // a. Let elementK be the result of ? Get(O, ! ToString(k)).
                // b. If SameValueZero(searchElement, elementK) is true, return true.
                if (sameValueZero(o[k], searchElement)) {
                    return true;
                }
                // c. Increase k by 1.
                k++;
            }

            // 8. Return false
            return false;
        }
    });
}

},{}],4:[function(require,module,exports){
'use strict'; /* global window, document, navigator, MdiNativeShell, location */

(function ($, window) {

    var jQuery = $;
    require('./polyfills.js');
    var appFunctions = require('./appFunctions');
    var utils = require('./mdiUtils');
    require('../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/transition.js');
    require('../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/carousel.js');
    require('../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/modal.js');

    window.formShow = utils.whichDesktopShow;
    window.formShowWithError = utils.errorShow;
    window.showEntryForm = utils.showEntryForm;
    window.showTicketTypes = utils.showManualChoices;
    window.queryStringValue = utils.queryStringValue;
    window.getKeyValueFromQuery = utils.getKeyValueFromQuery;
    window.mdiIsNativeShell = appFunctions.mdiIsNativeShell;
    window.startScan = appFunctions.mdiStartScan;
    window.autotab = utils.autotab;
    window.sourceSwap = utils.altSourceSwap;
    window.ieVersion = utils.ieVersion;

    $(document).ready(function () {
        // nav highlighting
        $('.nav-list a').each(function () {
            var href = $(this).attr('href');
            if (href.replace(/(#.*|\?.*|.php)/g, '') === window.location.pathname.replace(/(#.*|\?.*|.php)/g, '')) {
                $(this).addClass('active');
            } else if (href.replace(/(#.*|\?.*|.php)/g, '') === window.location.pathname.replace(/(#.*|\?.*|.php)/g, '').substr(0, window.location.pathname.length - 1)) {
                $(this).addClass('active');
            }
        });

        // app functionality
        if (window.mdiIsNativeShell() && !!document.querySelector('.enter')) {
            $('.scanner').click(window.startScan);
        }

        // help page submit debounce
        if (!!document.querySelector('.help')) {
            $('input.btn').on('click', function (e) {
                this.disabled = true;
                this.form.constructor.prototype.submit.call(this.form);
            });
        }

        // enter now page submit debounce
        if (!!document.querySelector('.enter')) {
            $('#entry-submit').on('click', function (e) {
                this.disabled = true;
                this.form.constructor.prototype.submit.call(this.form);
            });
        }

        $('.form-back-button').click(function () {
            if (window.mdiIsNativeShell()) {
                $('#entry-view').hide();
                $('#desktop-landing').show();
            } else {
                $('#entry-view').hide();
                $('#desktop-landing').show();

                if (typeof initSameHeight !== 'undefined') {
                    initSameHeight();
                }
            }

            // clear entry fields
            $('#game-number, #ticket1_1_1, #ticket1_2_1, #ticket1_2_2, #ticket1_2_3').val('');
        });

        if (location.search.indexOf('in1') > -1) {
            showEntryForm('draw');
            $('#ticket1_1_1').val(queryStringValue('in1'));
            $('#ticket1_1_2').val(queryStringValue('in2'));
            $('#ticket1_1_3').val(queryStringValue('in3'));
            $('#ticket1_1_4').val(queryStringValue('in4'));
            $('#ticket1_1_5').val(queryStringValue('in5'));
        } else if (localStorage.getItem('entryQueryString')) {
            var queryString = localStorage.getItem('entryQueryString');
            var localStorageQuery = getKeyValueFromQuery(queryString);

            showEntryForm('draw');
            $('#ticket1_1_1').val(localStorageQuery('in1'));
            $('#ticket1_1_2').val(localStorageQuery('in2'));
            $('#ticket1_1_3').val(localStorageQuery('in3'));
            $('#ticket1_1_4').val(localStorageQuery('in4'));
            $('#ticket1_1_5').val(localStorageQuery('in5'));
        }

        // remove entryQueryString
        localStorage.removeItem('entryQueryString');

        $('#app-manual-entry').click(window.showTicketTypes);

        if (window.errorShowForm && window.errorShowForm !== '') {
            showEntryForm(parseInt(errorShowForm));
        }
    });

    // set exact iframe width before loading animation
    (function iframeSetup() {
        var $frame = $('iframe');
        $frame.attr('width', $($frame.parent()).width());
        $frame.attr('src', $frame.attr('data-src'));
    })();

    // use clicks on the homepage animation
    // to forward them to relevant howtoenter section
    (function iframeClicks() {
        var $overlay = $('<div class="iframe-mask">');
        var $frame = $('iframe');
        var carouselPositions = {
            'scratch-off': 0,
            'draw': 1,
            'fast-play': 2
        };

        var getTarget = function getTarget(position, width) {
            if (position / width < 1 / 3) {
                return 'scratch-off';
            } else if (position / width < 2 / 3) {
                return 'draw';
            } else {
                return 'fast-play';
            }
        };

        $frame.before($overlay);
        $overlay.on('click', function (e) {
            var offset = $overlay.offset();
            var x = e.pageX - offset.left;
            var location = getTarget(x, $frame.width());
            window.location = '/springfling2019/howtoenter#' + location;
        });
    })();
})($jq, window);

},{"../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/carousel.js":5,"../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/modal.js":6,"../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/transition.js":7,"./appFunctions":1,"./mdiUtils":2,"./polyfills.js":3}],5:[function(require,module,exports){
/* ========================================================================
 * Bootstrap: carousel.js v3.3.6
 * http://getbootstrap.com/javascript/#carousel
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CAROUSEL CLASS DEFINITION
  // =========================

  var Carousel = function (element, options) {
    this.$element    = $(element)
    this.$indicators = this.$element.find('.carousel-indicators')
    this.options     = options
    this.paused      = null
    this.sliding     = null
    this.interval    = null
    this.$active     = null
    this.$items      = null

    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))

    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
  }

  Carousel.VERSION  = '3.3.6'

  Carousel.TRANSITION_DURATION = 600

  Carousel.DEFAULTS = {
    interval: 5000,
    pause: 'hover',
    wrap: true,
    keyboard: true
  }

  Carousel.prototype.keydown = function (e) {
    if (/input|textarea/i.test(e.target.tagName)) return
    switch (e.which) {
      case 37: this.prev(); break
      case 39: this.next(); break
      default: return
    }

    e.preventDefault()
  }

  Carousel.prototype.cycle = function (e) {
    e || (this.paused = false)

    this.interval && clearInterval(this.interval)

    this.options.interval
      && !this.paused
      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))

    return this
  }

  Carousel.prototype.getItemIndex = function (item) {
    this.$items = item.parent().children('.item')
    return this.$items.index(item || this.$active)
  }

  Carousel.prototype.getItemForDirection = function (direction, active) {
    var activeIndex = this.getItemIndex(active)
    var willWrap = (direction == 'prev' && activeIndex === 0)
                || (direction == 'next' && activeIndex == (this.$items.length - 1))
    if (willWrap && !this.options.wrap) return active
    var delta = direction == 'prev' ? -1 : 1
    var itemIndex = (activeIndex + delta) % this.$items.length
    return this.$items.eq(itemIndex)
  }

  Carousel.prototype.to = function (pos) {
    var that        = this
    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))

    if (pos > (this.$items.length - 1) || pos < 0) return

    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
    if (activeIndex == pos) return this.pause().cycle()

    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
  }

  Carousel.prototype.pause = function (e) {
    e || (this.paused = true)

    if (this.$element.find('.next, .prev').length && $.support.transition) {
      this.$element.trigger($.support.transition.end)
      this.cycle(true)
    }

    this.interval = clearInterval(this.interval)

    return this
  }

  Carousel.prototype.next = function () {
    if (this.sliding) return
    return this.slide('next')
  }

  Carousel.prototype.prev = function () {
    if (this.sliding) return
    return this.slide('prev')
  }

  Carousel.prototype.slide = function (type, next) {
    var $active   = this.$element.find('.item.active')
    var $next     = next || this.getItemForDirection(type, $active)
    var isCycling = this.interval
    var direction = type == 'next' ? 'left' : 'right'
    var that      = this

    if ($next.hasClass('active')) return (this.sliding = false)

    var relatedTarget = $next[0]
    var slideEvent = $.Event('slide.bs.carousel', {
      relatedTarget: relatedTarget,
      direction: direction
    })
    this.$element.trigger(slideEvent)
    if (slideEvent.isDefaultPrevented()) return

    this.sliding = true

    isCycling && this.pause()

    if (this.$indicators.length) {
      this.$indicators.find('.active').removeClass('active')
      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
      $nextIndicator && $nextIndicator.addClass('active')
    }

    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
    if ($.support.transition && this.$element.hasClass('slide')) {
      $next.addClass(type)
      $next[0].offsetWidth // force reflow
      $active.addClass(direction)
      $next.addClass(direction)
      $active
        .one('bsTransitionEnd', function () {
          $next.removeClass([type, direction].join(' ')).addClass('active')
          $active.removeClass(['active', direction].join(' '))
          that.sliding = false
          setTimeout(function () {
            that.$element.trigger(slidEvent)
          }, 0)
        })
        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
    } else {
      $active.removeClass('active')
      $next.addClass('active')
      this.sliding = false
      this.$element.trigger(slidEvent)
    }

    isCycling && this.cycle()

    return this
  }


  // CAROUSEL PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.carousel')
      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
      var action  = typeof option == 'string' ? option : options.slide

      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
      if (typeof option == 'number') data.to(option)
      else if (action) data[action]()
      else if (options.interval) data.pause().cycle()
    })
  }

  var old = $.fn.carousel

  $.fn.carousel             = Plugin
  $.fn.carousel.Constructor = Carousel


  // CAROUSEL NO CONFLICT
  // ====================

  $.fn.carousel.noConflict = function () {
    $.fn.carousel = old
    return this
  }


  // CAROUSEL DATA-API
  // =================

  var clickHandler = function (e) {
    var href
    var $this   = $(this)
    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
    if (!$target.hasClass('carousel')) return
    var options = $.extend({}, $target.data(), $this.data())
    var slideIndex = $this.attr('data-slide-to')
    if (slideIndex) options.interval = false

    Plugin.call($target, options)

    if (slideIndex) {
      $target.data('bs.carousel').to(slideIndex)
    }

    e.preventDefault()
  }

  $(document)
    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)

  $(window).on('load', function () {
    $('[data-ride="carousel"]').each(function () {
      var $carousel = $(this)
      Plugin.call($carousel, $carousel.data())
    })
  })

}(jQuery);

},{}],6:[function(require,module,exports){
/* ========================================================================
 * Bootstrap: modal.js v3.3.6
 * http://getbootstrap.com/javascript/#modals
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // MODAL CLASS DEFINITION
  // ======================

  var Modal = function (element, options) {
    this.options             = options
    this.$body               = $(document.body)
    this.$element            = $(element)
    this.$dialog             = this.$element.find('.modal-dialog')
    this.$backdrop           = null
    this.isShown             = null
    this.originalBodyPad     = null
    this.scrollbarWidth      = 0
    this.ignoreBackdropClick = false

    if (this.options.remote) {
      this.$element
        .find('.modal-content')
        .load(this.options.remote, $.proxy(function () {
          this.$element.trigger('loaded.bs.modal')
        }, this))
    }
  }

  Modal.VERSION  = '3.3.6'

  Modal.TRANSITION_DURATION = 300
  Modal.BACKDROP_TRANSITION_DURATION = 150

  Modal.DEFAULTS = {
    backdrop: true,
    keyboard: true,
    show: true
  }

  Modal.prototype.toggle = function (_relatedTarget) {
    return this.isShown ? this.hide() : this.show(_relatedTarget)
  }

  Modal.prototype.show = function (_relatedTarget) {
    var that = this
    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })

    this.$element.trigger(e)

    if (this.isShown || e.isDefaultPrevented()) return

    this.isShown = true

    this.checkScrollbar()
    this.setScrollbar()
    this.$body.addClass('modal-open')

    this.escape()
    this.resize()

    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))

    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
      })
    })

    this.backdrop(function () {
      var transition = $.support.transition && that.$element.hasClass('fade')

      if (!that.$element.parent().length) {
        that.$element.appendTo(that.$body) // don't move modals dom position
      }

      that.$element
        .show()
        .scrollTop(0)

      that.adjustDialog()

      if (transition) {
        that.$element[0].offsetWidth // force reflow
      }

      that.$element.addClass('in')

      that.enforceFocus()

      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })

      transition ?
        that.$dialog // wait for modal to slide in
          .one('bsTransitionEnd', function () {
            that.$element.trigger('focus').trigger(e)
          })
          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
        that.$element.trigger('focus').trigger(e)
    })
  }

  Modal.prototype.hide = function (e) {
    if (e) e.preventDefault()

    e = $.Event('hide.bs.modal')

    this.$element.trigger(e)

    if (!this.isShown || e.isDefaultPrevented()) return

    this.isShown = false

    this.escape()
    this.resize()

    $(document).off('focusin.bs.modal')

    this.$element
      .removeClass('in')
      .off('click.dismiss.bs.modal')
      .off('mouseup.dismiss.bs.modal')

    this.$dialog.off('mousedown.dismiss.bs.modal')

    $.support.transition && this.$element.hasClass('fade') ?
      this.$element
        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
      this.hideModal()
  }

  Modal.prototype.enforceFocus = function () {
    $(document)
      .off('focusin.bs.modal') // guard against infinite focus loop
      .on('focusin.bs.modal', $.proxy(function (e) {
        if (this.$element[0] !== e.target && !this.$element.has(e.target).length) {
          this.$element.trigger('focus')
        }
      }, this))
  }

  Modal.prototype.escape = function () {
    if (this.isShown && this.options.keyboard) {
      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
        e.which == 27 && this.hide()
      }, this))
    } else if (!this.isShown) {
      this.$element.off('keydown.dismiss.bs.modal')
    }
  }

  Modal.prototype.resize = function () {
    if (this.isShown) {
      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
    } else {
      $(window).off('resize.bs.modal')
    }
  }

  Modal.prototype.hideModal = function () {
    var that = this
    this.$element.hide()
    this.backdrop(function () {
      that.$body.removeClass('modal-open')
      that.resetAdjustments()
      that.resetScrollbar()
      that.$element.trigger('hidden.bs.modal')
    })
  }

  Modal.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove()
    this.$backdrop = null
  }

  Modal.prototype.backdrop = function (callback) {
    var that = this
    var animate = this.$element.hasClass('fade') ? 'fade' : ''

    if (this.isShown && this.options.backdrop) {
      var doAnimate = $.support.transition && animate

      this.$backdrop = $(document.createElement('div'))
        .addClass('modal-backdrop ' + animate)
        .appendTo(this.$body)

      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
        if (this.ignoreBackdropClick) {
          this.ignoreBackdropClick = false
          return
        }
        if (e.target !== e.currentTarget) return
        this.options.backdrop == 'static'
          ? this.$element[0].focus()
          : this.hide()
      }, this))

      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

      this.$backdrop.addClass('in')

      if (!callback) return

      doAnimate ?
        this.$backdrop
          .one('bsTransitionEnd', callback)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callback()

    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass('in')

      var callbackRemove = function () {
        that.removeBackdrop()
        callback && callback()
      }
      $.support.transition && this.$element.hasClass('fade') ?
        this.$backdrop
          .one('bsTransitionEnd', callbackRemove)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callbackRemove()

    } else if (callback) {
      callback()
    }
  }

  // these following methods are used to handle overflowing modals

  Modal.prototype.handleUpdate = function () {
    this.adjustDialog()
  }

  Modal.prototype.adjustDialog = function () {
    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight

    this.$element.css({
      paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
    })
  }

  Modal.prototype.resetAdjustments = function () {
    this.$element.css({
      paddingLeft: '',
      paddingRight: ''
    })
  }

  Modal.prototype.checkScrollbar = function () {
    var fullWindowWidth = window.innerWidth
    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
      var documentElementRect = document.documentElement.getBoundingClientRect()
      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
    }
    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
    this.scrollbarWidth = this.measureScrollbar()
  }

  Modal.prototype.setScrollbar = function () {
    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
    this.originalBodyPad = document.body.style.paddingRight || ''
    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
  }

  Modal.prototype.resetScrollbar = function () {
    this.$body.css('padding-right', this.originalBodyPad)
  }

  Modal.prototype.measureScrollbar = function () { // thx walsh
    var scrollDiv = document.createElement('div')
    scrollDiv.className = 'modal-scrollbar-measure'
    this.$body.append(scrollDiv)
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
    this.$body[0].removeChild(scrollDiv)
    return scrollbarWidth
  }


  // MODAL PLUGIN DEFINITION
  // =======================

  function Plugin(option, _relatedTarget) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.modal')
      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
      if (typeof option == 'string') data[option](_relatedTarget)
      else if (options.show) data.show(_relatedTarget)
    })
  }

  var old = $.fn.modal

  $.fn.modal             = Plugin
  $.fn.modal.Constructor = Modal


  // MODAL NO CONFLICT
  // =================

  $.fn.modal.noConflict = function () {
    $.fn.modal = old
    return this
  }


  // MODAL DATA-API
  // ==============

  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
    var $this   = $(this)
    var href    = $this.attr('href')
    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())

    if ($this.is('a')) e.preventDefault()

    $target.one('show.bs.modal', function (showEvent) {
      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
      $target.one('hidden.bs.modal', function () {
        $this.is(':visible') && $this.trigger('focus')
      })
    })
    Plugin.call($target, option, this)
  })

}(jQuery);

},{}],7:[function(require,module,exports){
/* ========================================================================
 * Bootstrap: transition.js v3.3.6
 * http://getbootstrap.com/javascript/#transitions
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
  // ============================================================

  function transitionEnd() {
    var el = document.createElement('bootstrap')

    var transEndEventNames = {
      WebkitTransition : 'webkitTransitionEnd',
      MozTransition    : 'transitionend',
      OTransition      : 'oTransitionEnd otransitionend',
      transition       : 'transitionend'
    }

    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return { end: transEndEventNames[name] }
      }
    }

    return false // explicit for ie8 (  ._.)
  }

  // http://blog.alexmaccaw.com/css-transitions
  $.fn.emulateTransitionEnd = function (duration) {
    var called = false
    var $el = this
    $(this).one('bsTransitionEnd', function () { called = true })
    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
    setTimeout(callback, duration)
    return this
  }

  $(function () {
    $.support.transition = transitionEnd()

    if (!$.support.transition) return

    $.event.special.bsTransitionEnd = {
      bindType: $.support.transition.end,
      delegateType: $.support.transition.end,
      handle: function (e) {
        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
      }
    }
  })

}(jQuery);

},{}]},{},[4]);
